export default {"src":"/_next/static/media/debut-logo.12025015.svg","height":49,"width":250,"blurWidth":0,"blurHeight":0};